import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SubjectProvider } from './pages/SubjectsContext';
import { AuthProvider } from './pages/AuthContext';
import ProtectedRoute from './ProtectedRoute';
import { ToastContainer } from 'react-toastify';

// Lazy loaded pages
const Home = lazy(() => import('./pages/Home'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const Login = lazy(() => import('./pages/Login'));
const Register = lazy(() => import('./pages/Register'));
const NewJoin = lazy(() => import('./pages/NewJoin'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const CoursesPage = lazy(() => import('./pages/Courses/CoursePage'));
const SubjectPage = lazy(() => import('./pages/Courses/SubjectPage'));
const Blogs = lazy(() => import('./pages/Courses/Blogs'));
const CreateBlog = lazy(() => import('./pages/Courses/CreateBlog'));
const SlugBlog = lazy(() => import('./pages/Courses/SlugBlog'));
const Notes = lazy(() => import('./pages/Courses/Notes'));
const Test = lazy(() => import('./pages/Courses/Test'));
const Structure = lazy(() => import('./pages/Courses/Structure'));
const Subjects = lazy(() => import('./pages/Courses/Subjects'));
const UserCourse = lazy(() => import('./pages/Courses/UserCourse'));
const VerifyEmail = lazy(() => import('./pages/VerifyEmail'));
const Forget = lazy(() => import('./pages/Forget'));
const Payment = lazy(() => import('./pages/Payment'));
const ClassesSchedule = lazy(() => import('./pages/Courses/ClassesSchedule'));
const PrivacyPage = lazy(() => import('./pages/Courses/PrivacyPage'));
const TermsAndConditions = lazy(() => import('./pages/Courses/TermAndConditions'));
const Cancellation = lazy(() => import('./pages/Courses/Cancellation'));
const NotFound = lazy(() => import('./pages/NotFound'));
const StudentList = lazy(() => import('./pages/Students/StudentList'));
const ReportsPage = lazy(() => import('./pages/Students/ReportsPage'));
// const QAndA = lazy(() => import('./pages/QAndA'));
// const AllQAndA=lazy(()=>import('./pages/AllQAndA'));

function App() {
  return (
    <AuthProvider>
      <SubjectProvider>
        <Router>
          <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '50px' }}>Loading...</div>}>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/aboutus" element={<AboutUs />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/verify" element={<VerifyEmail />} />
              <Route path="/forget" element={<Forget />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsAndConditions />} />
              <Route path="/cancellation" element={<Cancellation />} />
              <Route path="/course/:subject" element={<SubjectPage />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/blog/:slug" element={<SlugBlog />} />
              <Route path="/courses" element={<CoursesPage />} />
              <Route path="/course/:subject/structure" element={<Structure />} />
              {/* <Route path='/allquestans' element={<AllQAndA />} /> */}

              {/* Protected for User OR Admin Or employee or instructor */}
              <Route path="/newblog/:id?" element={
                <ProtectedRoute role="any">
                  <CreateBlog />
                </ProtectedRoute>
              } />
              <Route path="/sendenquiry" element={
                <ProtectedRoute role="any">
                  <Payment />
                </ProtectedRoute>
              } />
              <Route path="/usercourse" element={
                <ProtectedRoute role="any">
                  <UserCourse />
                </ProtectedRoute>
              } />
              <Route path="/userclasses" element={
                <ProtectedRoute role="any">
                  <ClassesSchedule />
                </ProtectedRoute>
              } />
              <Route path="/course/:subject/notes" element={
                <ProtectedRoute role="any">
                  <Notes />
                </ProtectedRoute>
              } />
              <Route path="/tests" element={
                <ProtectedRoute role="any">
                  <Test />
                </ProtectedRoute>
              } />

              {/* Admin Only */}
              <Route path="/dashboard" element={
                <ProtectedRoute role="admin">
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/subjects" element={
                <ProtectedRoute role="admin">
                  <Subjects />
                </ProtectedRoute>
              } />
              <Route path="/newjoinregister" element={
                <ProtectedRoute role="admin">
                  <NewJoin />
                </ProtectedRoute>
              } />

{/* only for instructor */}
<Route path="/allsubjectstudent" element={
                <ProtectedRoute role="instructor">
                  <StudentList />
                </ProtectedRoute>  
              } />
                 <Route path="/allreports" element={
                <ProtectedRoute role="instructor">
                  <ReportsPage />
                </ProtectedRoute>  
              } />

              {/* 404 Fallback */}
              <Route path="/404" element={<NotFound />} />
              



              {/* only for employee */}
            {/* <Route path='/qasection' element={
              <ProtectedRoute role="employee">
                <QAndA />
              </ProtectedRoute>
            } /> */}
            </Routes>

            <ToastContainer position="top-center" autoClose={3000} />
          </Suspense>
        </Router>
      </SubjectProvider>
    </AuthProvider>
  );
}

export default App;
